import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { getMessage } from '@/helpers/utils';
import Notify from '@/components/Notification';
import i18n from '@/i18n';
import { investingService } from '../../services/investingService';

const { t } = i18n;

export const useResetInvesting = () => {
  const queryClient = useQueryClient();

  return useMutation({
    retry: false,
    mutationFn: () =>
      investingService.resetInvesting().then(response => {
        const { status, data } = response;
        if (status === 200) {
          Notify.success({ text: t('kit:notify.investing_reset_success') });
          queryClient.setQueryData([QUERY_KEYS.investing.status], () => data);
          queryClient.setQueryData(
            [QUERY_KEYS.investing.pre_allocate_info],
            () => null,
          );
          queryClient.refetchQueries({
            queryKey: [QUERY_KEYS.investing.fundraising_stats],
          });
          queryClient.refetchQueries({
            queryKey: [QUERY_KEYS.cash.balance],
          });
          queryClient.refetchQueries({
            queryKey: [QUERY_KEYS.investing.allocate_info],
          });
          queryClient.invalidateQueries({
            queryKey: [QUERY_KEYS.investing.invested_in_groups_stats],
          });
          queryClient.resetQueries({
            queryKey: [QUERY_KEYS.investing.investment_brands],
          });
          queryClient.invalidateQueries({
            queryKey: [QUERY_KEYS.investing.invested_countries],
          });
          return data;
        }
        Notify.error({
          text: getMessage(data, t('kit:notify.investing_reset_failed')),
        });

        console.error(data?.message);
      }),
  });
};
